import PropTracker from "../../prop-trackers/prop-tracker.js";
import SinglePropTracker from "../../prop-trackers/single-prop-tracker.js";
import PropChainTracker from "../../prop-tracker-utils/prop-chain-tracker.js";
import DictTrackerObjPtrGen from "../../prop-tracker-utils/dict-tracker-obj-ptr-gen.js";

import ObjectValueGenerator from "./trackers/objects/animations/object-value-generator.js";

class ObjectAnimValues {
    constructor(wrapCtx, evtCtx) {
        this._objectAnimKeyTracker = new PropChainTracker(evtCtx);
        this._objectTrackTracker = new PropChainTracker(evtCtx);
        this._animTracker = new PropTracker();
        this._timeTracker = new SinglePropTracker();

        const objValGen = new ObjectValueGenerator(this._objectAnimKeyTracker, this._objectTrackTracker, this._animTracker, this._timeTracker, wrapCtx, evtCtx);
        this._valueGen = new DictTrackerObjPtrGen(wrapCtx, evtCtx, objValGen);
    }

    get values() { return this._valueGen.pointer; }

    track(session, objectAnimKeys, objectTracks, animations) {
        if (objectAnimKeys) {
            this._objectAnimKeyTracker.track(objectAnimKeys.data, ["value"]);
        } else {
            this._objectAnimKeyTracker.track();
        }

        if (objectTracks) {
            this._objectTrackTracker.track(objectTracks.data, ["value"]);
        } else {
            this._objectTrackTracker.track();
        }

        if (animations) {
            this._animTracker.track(animations.data, animations.events);
        } else {
            this._animTracker.track();
        }

        if (session) {
            this._timeTracker.track(session.data, session.events, "time");
        } else {
            this._timeTracker.track();
        }

        if (session || objectAnimKeys || objectTracks || animations) {
            this._valueGen.start();
        } else {
            this._valueGen.stop();
        }
    }

    update() {
        this._valueGen.update();
    }
}

export default ObjectAnimValues;
